import http from './http';

export default {
  getPublicConfig() { return http.get('/config').then((r) => r.data.data); },
};
